const momentTz = require('moment-timezone');
import moment from "moment";
import axios from "axios";
import Login from "@/services/login";
import Home from "@/services/Home";
import Notification from "@/services/Notification";
import CommonApi from "@/services/Common";
import WSApi from "@/services/WeatherStation";
import User from "@/services/user";

let fetchPending = null;

const lib = {};

lib.loginAction = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    Login.validateUser(payload)
      .then((res) => {
        const plantDetails = res.data.data;
        if (res.status === 206) {
          commit("SET_SHOW_SNACKBAR", true);
          commit("SET_SNACKBAR_CONTENT", {
            icon: "error",
            timeout: 5000,
            header: "",
            message: res.data.message,
          });
          const customError = new Error(res.data.message);
          reject(customError)
          return
        }
        if (res.status === 200) {
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + res.data.token;
          const userData = {
            refreshTime: res.data.refreshTime * 60000,
            role: res.data.role,
            lastNotificationViewed: res.data.lastViewedNotificationTime,
            userName: res.data.name,
            userId: res.data.user_id,
            email: res.data.email,
            logo: res.data.logo,
            banner_messages: res.data.banner_messages,
          };
          commit("SET_USER_DATA", userData);
          commit("SET_RELOAD_TIMER", res.data.refreshTime);

          const timeZone = plantDetails[0].timezone
          if (plantDetails.length > 1) {
            commit("SET_SHOW_HOME_DB", true);
          } else {
            // Logic for Users who has only 1 plant
            const renewDate = plantDetails[0].renew_date;
            
            if (renewDate && momentTz().tz(timeZone).isAfter(moment(renewDate))) {
              commit("SET_SHOW_HOME_DB", true);
            } else {
              commit("SET_SHOW_HOME_DB", false);
            }
          }
          let expiredPlantCount = 0;
          let renewPlantCount = 0;
          let aboutToExpireCount = 0;
          const remappedData = plantDetails.reduce((holder, data) => {
            const {
              plant_id: plantId,
              expiry_date: expiryDate,
              renew_date: renewDate,
              module_brand: moduleBrand,
            } = data;
            commit("SET_MODULE_BRAND", {
              plant_id: plantId,
              brand: moduleBrand,
            });
            if (renewDate && momentTz().tz(timeZone).isAfter(moment(renewDate))) {
              if (expiryDate && momentTz().tz(timeZone).isAfter(moment(expiryDate))) {
                expiredPlantCount++;
              } else {
                renewPlantCount++;
              }
            } else if (
              expiryDate &&
              moment(expiryDate).diff(momentTz().tz(timeZone), "days") >= 0 &&
              moment(expiryDate).diff(momentTz().tz(timeZone), "days") <= 30
            ) {
              aboutToExpireCount++;
            }

            holder[data.plant_id] = data;
            return holder;
          }, {});

          commit("SET_EXPIRED_PLANT_COUNT", expiredPlantCount);
          commit("SET_RENEW_PLANT_COUNT", renewPlantCount);
          commit("SET_PLANT_NEAR_EXPIRY_COUNT", aboutToExpireCount);

          commit("SET_PLANT_DATA", remappedData);
          commit("SET_ACTIVE_PLANT", plantDetails[0]);
        }

        resolve(res);
      })
      .catch((err) => {
        console.log("ERR", err);
        reject(err);
      });
  });
};

lib.fetchGenerationData = async ({ commit, getters }, payload) => {
  return new Promise(async (resolve, reject) => {
    const param = {
      plantList: payload,
    };
    var response = await Home.dashboardData(param);
    if (response.status == 200) {
      let energyToday = 0;
      let data = [];

      Object.values(response.data.message).forEach((element) => {
        let plantDetails = Object.assign({}, element);
        energyToday += parseFloat(element.generation);
        plantDetails["plant_name"] = getters.getActivePlantInfo(
          "plant_name",
          element.plant_id
        );
        plantDetails["location"] = getters.getActivePlantInfo(
          "state",
          element.plant_id
        );
        plantDetails["generation"] = element.generation || 0;

        data.push(plantDetails);
      });

      commit("SET_PLANT_TOTAL_GENERATION", energyToday);
      commit("SET_TOTAL_GENERATION", energyToday);
      response.data.message = data;
      resolve(response);
    } else {
      reject(err);
    }
  });
};

lib.fetchNotification = ({ commit }, payload) => {
  const idCsv = payload.idList.join();
  const base64data = btoa(idCsv);

  if (!fetchPending) {
    console.log(
      "fetching notifications",
      base64data,
      payload.skip,
      payload.limit
    );
    commit("SET_PROGRESS_BAR", true);
    fetchPending = Notification.fetchNotification(
      base64data,
      payload.skip,
      payload.limit
    )
      .then((res) => {
        commit("APPEND_NOTIFICATION", res.data.message);
        commit("SET_PROGRESS_BAR", false);
        fetchPending = null;
      })
      .catch((err) => {
        console.log(err);
        commit("SET_PROGRESS_BAR", false);
        fetchPending = null;
      });
  }
};

lib.fetchBlockList = async ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    let response = await CommonApi.getDeviceBlockList(...payload);
    if (response.status === 200) {
      commit("SET_ID_LIST", { name: "blockList", data: response.data.message });
      resolve(response);
    } else {
      reject(new Error(response));
    }
  });
};

lib.fetchIdList = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    let response = await CommonApi.getIdList(...payload);
    if (response.status === 200) {
      commit("SET_ID_LIST", { name: "idList", data: response.data.message });
      resolve(response);
    } else {
      reject(new Error(response));
    }
  });
};

lib.fetchWsList = async ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    let response = await WSApi.wsList(payload);
    console.log("FETCH WS LIST", response, payload);
    if (response.status === 200) {
      const wsList = [];
      for (let value of response.data.message) {
        const list = {
          text: value.ws_name,
          value: value.ws_id,
        };
        wsList.push(list);
      }
      response.data.message.length = 0;
      response.data.message = [...wsList];
      console.log(wsList, "WS LIST");
      commit("SET_ID_LIST", { name: "wsList", data: wsList });
      resolve(response);
    } else {
      reject(new Error(response));
    }
  });
};

lib.fetchNotificationCount = ({ commit }, payload) => {
  const idCsv = payload.join();
  const base64data = btoa(idCsv);

  Notification.fetchNotificationCount(base64data).then((res) => {
    commit("SET_NOTIFICATION_COUNT", res.data.message);
  });
};

lib.appendNotification = ({ commit }, notification) => {
  commit("APPEND_NOTIFICATION", notification);
};

lib.appendNewNotification = ({ commit }, notification) => {
  commit("APPEND_NEW_NOTIFICATION", notification);
};

lib.setLatestNotificationViewTimestamp = ({ commit }, payload) => {
  console.log(payload);
  User.updateUserDetails(payload)
    .then((res) => {
      commit(
        "SET_LATEST_NOTIFICATION_VIEW_TIMESTAMP",
        payload.details.last_viewed_notification_time
      );
    })
    .catch((err) => {
      console.log(err);
    });
};

lib.resetState = ({ commit }) => {
  function reset(arr) {
    for (const element of arr) {
      if (element) {
        commit(`${element}/RESET_STATE`, null, {
          root: true,
        });
      } else {
        commit("RESET_STATE");
      }
    }
  }

  const components = [
    "settings",
    "alert",
    "analytics",
    "theme",
    "report",
    null,
  ];
  reset(components);
};

export default lib;
